import { useState } from "react";

interface ResizeHandleProps {
  direction: "horizontal" | "vertical";
  onMouseDown: (e: React.MouseEvent) => void;
  isDragging: boolean;
}

export default function ResizeHandle({
  direction,
  onMouseDown,
  isDragging,
}: ResizeHandleProps) {
  const [isHovered, setIsHovered] = useState(false);

  const isActive = isDragging || isHovered;

  const baseClasses = "hidden md:block absolute transition-colors z-10";
  const activeClasses = isActive ? "bg-primary/50" : "bg-transparent hover:bg-base-300";

  if (direction === "horizontal") {
    return (
      <div
        className={`${baseClasses} ${activeClasses} w-1 cursor-col-resize`}
        style={{
          top: 0,
          bottom: 0,
          right: -2,
        }}
        onMouseDown={onMouseDown}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      />
    );
  }

  return (
    <div
      className={`${baseClasses} ${activeClasses} h-1 cursor-row-resize`}
      style={{
        left: 0,
        right: 0,
        top: -2,
      }}
      onMouseDown={onMouseDown}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    />
  );
}
